import { useQuery } from '@tanstack/react-query';
import api from '@/services/api';
import type { PaginatedResponse, User } from '@/types/table';

/**
 * Login accounts, for pickers such as "link this employee to a login".
 * Read-only; team management lives in Settings → Team.
 */
export function useUsers() {
  const query = useQuery({
    queryKey: ['users', 'list'],
    queryFn: async () => {
      const res = await api.get<PaginatedResponse<User>>('/users', { params: { limit: 100 } });
      return res.data;
    },
    staleTime: 60_000,
  });

  return { users: query.data?.data ?? [], isLoading: query.isLoading };
}
